import { Get, Post, Put } from "domain/infra/data/api";
import CarteiraConstants from "../../infra/data/carteiraConstants";
import { CarteiraPermissaoResponse } from "../../types/carteiraAdmin/carteiraPermissaoResponse";
import { PagedListRequest } from "domain/types/global/pagedListRequest";
import { UsuarioCarteiraResponse } from "../../types/carteiraAdmin/carteiraUsuarioResponse";
import { PagedListResponse } from "domain/types/global/pagedListResponse";
import { CARTEIRA_USUARIO_GET } from "../../types/carteiraAdmin/carteiraAdmin";
import { UpdateCarteiraPermissaoRequest } from "../../types/carteiraAdmin/updateCarteiraPermissaoRequest";
import { _UserData, UserDataBaseEnum } from "base/src/infra/storage/localStorage";

export class CarteiraAdminService {
  constructor() {
    
  }

  async GetCarteiraPermissao(carteiraId: number, dispatchName:string): Promise<CarteiraPermissaoResponse | Error> {
    return await Get(CarteiraConstants.apiCarteira.carteiraAdmin.getCarteiraPermissao(carteiraId, _UserData.Get(UserDataBaseEnum.UsuarioID)), dispatchName)
  }

  
  async GetUsuarioCarteira(carteiraId: number, request: PagedListRequest<UsuarioCarteiraResponse>): Promise<PagedListResponse<UsuarioCarteiraResponse> | Error> {
    return await Post(CarteiraConstants.apiCarteira.carteiraAdmin.getUsuarioCarteira(carteiraId), request, CARTEIRA_USUARIO_GET)
  }

  async AtualizarPermissao(carteiraId: number, usuarioId: number, request: UpdateCarteiraPermissaoRequest, dispatchName: string): Promise<boolean | Error> {
    return await Put(CarteiraConstants.apiCarteira.carteiraAdmin.atualizarPermissao(carteiraId, usuarioId), request, dispatchName)
  }

}
